import React from "react"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { List, ListItem, styled } from "@mui/material"

import { useAppSelector } from "redux/hooks"
import { selectSettingsById } from "redux/features/settings/settingsSlice"
import { SettingsType } from "types"

type Props = {
  signedIn: boolean
  onClick: () => void
}

const MobileTopListComponent = ({ signedIn, onClick }: Props) => {
  const { t } = useTranslation()

  const settings = useAppSelector(
    (state) => selectSettingsById(state, 0) as SettingsType,
  )

  const MENU_ITEMS = signedIn
    ? settings?.navigation || []
    : [
        {
          name: "privacy",
          path: "/privacy",
        },
        {
          name: "terms",
          path: "/terms",
        },
      ]

  const menuList = MENU_ITEMS.map((item, index) => (
    <ListItem key={index}>
      <ListItemLink to={item.path} onClick={onClick}>
        {t(`menu.${item.name}`)}
      </ListItemLink>
    </ListItem>
  ))

  return <TopList>{menuList}</TopList>
}

export default MobileTopListComponent

const TopList = styled(List)(() => ({
  display: "flex",
  flexDirection: "column",
}))

const ListItemLink = styled(NavLink)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: "2.375rem",
  fontWeight: "700",
  height: "auto",
  letterSpacing: "0.03em",
  lineHeight: "normal",
  padding: "16px 0",
  textAlign: "center",
  width: "100%",
  "&.active": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: "6px",
    opacity: "1",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "1.375rem",
    fontWeight: "600",
  },
}))
